import React from 'react';
import { Button } from '../../ui/button';
import { Save, Download, RefreshCw, Edit3 } from 'lucide-react';

/**
 * Floating Action Bar - Sticky bottom bar for quick actions
 * Always accessible regardless of scroll position
 */
export default function FloatingActionBar({
  onSave,
  onExport,
  onRecalculate,
  onEditInputs,
  calculating = false,
  hasResults = false,
  showEditButton = false,
  className = ''
}) {
  return (
    <div className={`sticky bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 shadow-lg z-40 ${className}`}>
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-3 sm:py-4">
        <div className="flex flex-wrap items-center justify-between gap-2">
          {/* Left side - Edit button (only shown on analysis tabs) */}
          <div className="flex gap-2">
            {showEditButton && (
              <Button
                variant="outline"
                size="sm"
                onClick={onEditInputs}
                className="text-xs sm:text-sm"
              >
                <Edit3 className="h-4 w-4 sm:mr-2" />
                <span className="hidden sm:inline">Edit Inputs</span>
                <span className="sm:hidden">Edit</span>
              </Button>
            )}
          </div>

          {/* Right side - Main actions */}
          <div className="flex gap-2 ml-auto">
            <Button
              variant="default"
              size="sm"
              onClick={onRecalculate}
              disabled={calculating}
              className="text-xs sm:text-sm"
            >
              <RefreshCw className={`h-4 w-4 sm:mr-2 ${calculating ? 'animate-spin' : ''}`} />
              <span className="hidden sm:inline">{calculating ? 'Calculating...' : 'Recalculate'}</span>
              <span className="sm:hidden">{calculating ? '...' : 'Calc'}</span>
            </Button>

            {hasResults && (
              <>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={onSave}
                  className="text-xs sm:text-sm"
                >
                  <Save className="h-4 w-4 sm:mr-2" />
                  <span className="hidden sm:inline">Save</span>
                </Button>

                <Button
                  variant="outline"
                  size="sm"
                  onClick={onExport}
                  className="text-xs sm:text-sm"
                >
                  <Download className="h-4 w-4 sm:mr-2" />
                  <span className="hidden sm:inline">Export</span>
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
